import React, { useState, useEffect } from "react";
import KPIMetricForm from "./KPIMetricForm";
import { useKPI } from "providers/KPIProvider";
import { addMonths } from "date-fns";
import { formatUTCToIST, getDateObj } from "utils/app.util";
import "./KPIMetricModal.css";
import Loader from "components/Loader/Loader";

const KPIModal = ({ show, nodeData, onClose }) => {
  const [formRefs, setFormRefs] = useState([]);
  const [kpis, setKpis] = useState([]);
  const [validMonths, setValidMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const { getKPIMetricRecords } = useKPI();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  function handleSubmit() {
    try {
      // alert("running3");
      setSubmitLoading(true);
      formRefs.forEach((ref) => {
        ref.current?.submitForm();
      });
    } catch (err) {
      // alert("running2");
      console.log(err);
    } finally {
      // alert("running");
      // setSubmitLoading(false);
    }
  }

  useEffect(() => {
    if (show && nodeData.nodeId) {
      setLoading(true);
      getKPIMetricRecords(nodeData.nodeId)
        .then((res) => {
          const filteredKPIs = res.data.filter((item) => {
            const itemDate = new Date(item.startDate);
            const itemEndDate = new Date(item.endDate);
            const currentDate = new Date();

            const check =
              itemDate.getFullYear() + itemDate.getMonth() / 100 <=
                currentDate.getFullYear() + currentDate.getMonth() / 100 &&
              currentDate.getFullYear() + currentDate.getMonth() / 100 <=
                itemEndDate.getFullYear() + itemEndDate.getMonth() / 100;

            return check;
          });
          setKpis(filteredKPIs);
        })
        .catch((ex) => {
          console.log(ex);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [show, nodeData.nodeId, getKPIMetricRecords]);

  useEffect(() => {
    setFormRefs(kpis.map(() => React.createRef()));
  }, [kpis]);

  useEffect(() => {
    const currentDate = new Date();
    const previousMonthDate = addMonths(currentDate, -1);
    const startDate = new Date(formatUTCToIST(kpis[0]?.startDate));
    const dateValue = getDateObj(startDate)?.value;
    const startDateObj = getDateObj(startDate);
    const previousMonthDateObj = getDateObj(previousMonthDate);
    const currentDateObj = getDateObj(currentDate);
    if (!startDateObj || !previousMonthDateObj || !currentDateObj) {
      return;
    }
    let months;
    if (Number(dateValue) > Number(getDateObj(previousMonthDate)?.value)) {
      months = [getDateObj(currentDate)];
    } else {
      months = [getDateObj(previousMonthDate), getDateObj(currentDate)];
    }

    setValidMonths(months);
    setSelectedMonth(months.length === 1 ? months[0].value : months[1].value);
  }, [kpis]);

  if (!show) {
    return null;
  }

  return (
    <div className="kpi-metric-modal fixed inset-0 w-screen h-screen z-50 bg-black bg-opacity-80 font-inter">
      <div className="absolute inset-0 m-auto max-w-[500px] w-full h-max bg-white rounded-[10px]">
        <header className="flex justify-between items-center px-6 py-3">
          <span className="text-[16px] font-semibold">{nodeData.heading}</span>
          {kpis.length > 0 && (
            <div className="flex items-center gap-1">
              <span className="text-[11px] font-semibold whitespace-nowrap">
                Data View:{" "}
              </span>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                {validMonths.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </header>
        <div className="form-container mx-6 my-5 rounded-[10px]">
          <header className="form-header grid grid-flow-col auto-cols-fr ps-5 pe-12 py-3 gap-x-4 gap-y-3 font-semibold text-xs">
            <span className="font-semibold">KPI Title</span>
            <span className="font-semibold">KPI Target</span>
          </header>
          {loading ? (
            <div className="mx-auto h-6 w-6 my-12 animate-spin rounded-full border-2 border-solid border-[#55C880] border-t-transparent"></div>
          ) : kpis.length === 0 ? (
            <div className="text-center py-10 text-[#b4b2b2]">
              No KPI is added for the current month.
            </div>
          ) : (
            kpis.map((kpi, index) => (
              <React.Fragment key={kpi._id}>
                <KPIMetricForm
                  ref={formRefs[index]}
                  kpi={kpi}
                  metrics={kpi.metricRecords}
                  selectedMonth={selectedMonth}
                  validMonths={validMonths}
                  onClose={onClose}
                  setSubmitLoading={setSubmitLoading}
                />
              </React.Fragment>
            ))
          )}
        </div>
        <footer className="flex justify-between px-6 py-3">
          <button
            className="text-[14px] font-medium px-5 py-1.5 border border-[#D9D9D9] rounded-[6px]"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="text-[14px] w-[88px] text-white px-5 py-1.5 bg-[#55C880] rounded-[6px]"
            onClick={handleSubmit}
          >
            {submitLoading ? <Loader /> : "Submit"}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default KPIModal;
